/**
 * @generated SignedSource<<5d61cb12314a2e7e833aa931167bef7a>>
 * @relayHash 4b77e3b22e18494c839ec5b0470d1747
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-trade/550.0.0-2026-03-10T14:52:08.510Z/removePhotoLikeMutation

import { ConcreteRequest } from 'relay-runtime';
export type RemovePhotoLikeMutationInput = {
  clientMutationId?: string | null;
  photoLikeId?: string | null;
};
export type removePhotoLikeMutation$variables = {
  input: RemovePhotoLikeMutationInput;
};
export type removePhotoLikeMutation$data = {
  readonly removePhotoLikeMutation: {
    readonly success: boolean | null;
  } | null;
};
export type removePhotoLikeMutation = {
  response: removePhotoLikeMutation$data;
  variables: removePhotoLikeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RemovePhotoLikeMutationPayload",
    "kind": "LinkedField",
    "name": "removePhotoLikeMutation",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "removePhotoLikeMutation",
    "selections": (v1/*: any*/),
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "removePhotoLikeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "app-buyer-trade/550.0.0-2026-03-10T14:52:08.510Z/removePhotoLikeMutation",
    "metadata": {},
    "name": "removePhotoLikeMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "d07bd376305a7d0f463abfca3a42625d";

export default node;
